import { motion } from "framer-motion";

export default function OfferBanner() {
  return (
    <section aria-label="Limited time offer">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="bg-[color:var(--brand-red)] text-white relative overflow-hidden"
      >
        {/* Ribbon */}
        <div className="hidden md:block absolute -right-14 top-3 rotate-45 bg-white text-[color:var(--brand-red)] text-xs font-extrabold tracking-widest px-10 py-1 shadow-card">
          OFFER
        </div>

        <div className="container-max py-5">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div className="text-lg md:text-xl font-bold">
              OFFER: 2 Year Premium Plan + 1 Year FREE Internet
            </div>
            <a href="#contact" className="btn bg-white text-[color:var(--brand-red)] hover:opacity-90">
              Book Now — Limited Time
            </a>
          </div>
          <div className="mt-2 flex items-center gap-3 text-sm opacity-90">
            <span className="inline-flex items-center rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-bold tracking-widest">LIMITED</span>
            <p>Advanced booking available. Total 3 years of service value with this limited-period offer.</p>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
